import * as React from 'react';
import { Typography, Container, Box, IconButton } from '@mui/material';
import { Facebook, Instagram, X } from '@mui/icons-material';

function Footer() {

    return (
        <Box component="footer" sx={{ py: 3, px: 2, mt: 'auto', backgroundColor: 'rgba(255, 165, 0, 0.75)' }}>
            <Container maxWidth="sm" sx={{ textAlign: 'center' }} >
                <Typography>© {(new Date().getFullYear())} Recetar.io</Typography>
                <Box>
                    <IconButton aria-label="facebook" href="https://facebook.com">
                        <Facebook />
                    </IconButton>
                    <IconButton aria-label="x" href="https://x.com">
                        <X />
                    </IconButton>
                    <IconButton aria-label="instagram" href="https://instagram.com">
                        <Instagram />
                    </IconButton>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;
